module.exports = __webpack_public_path__ + "828fb888e50e0089b2d981a624adc104.svg";